import gql from "graphql-tag";

export const GET_CONTENT_REPORT = gql`
  query {
    RN {
      getContentReport
    }
  }
`;
